import { getFromLocalStore } from "store/localStore";

/**
 * @description prepares request
 *
 * @return string
 */
export const locale = () => getFromLocalStore("locale") || "en";
